

/**
 * Конфигурация движка
 */

export default class BurgundyEngineConfig {
    /**
     * Название микро-приложения для логина
     */
    public static loginApplicationName = 'authentication';

    /**
     * Использовать ассоциативный профиль пользователя
     */
    public static useAssociatedIdentifier = true;
}


/**
 * Конфигурация движка
 */

export default class BurgundyEngineConfig {
    /**
     * Название микро-приложения для логина
     */
    public static loginApplicationName = 'authentication';

    /**
     * Использовать ассоциативный профиль пользователя
     */
    public static useAssociatedIdentifier = true;
}
